import { useEffect } from "react";

function useCreateScriptTag(url) {
	useEffect(() => {
		const script = document.createElement("script");
		script.src = url;
		script.async = true;
		document.body.appendChild(script);

		return () => {
			document.body.removeChild(script);
		};
	}, [url]);

	return true;
}

export { useCreateScriptTag };
